// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2gjGM","gfeWrapper":"CalendarEvent_gfeWrapper__1mQ3E"};